import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, catchError, concatMap, delay, iif, of, retryWhen, throwError } from 'rxjs';
import { AuthenticationService } from '../services/authentication.service';
import { environment } from 'src/environments/environment';

export interface RetryRequestOptions {
  maximumRetries: number;
  retryDelay: number;
}

@Injectable()
export class HttpAuthInterceptor implements HttpInterceptor {
  // default retry options
  private retryRequestOptions: RetryRequestOptions = {
    maximumRetries: 2,
    retryDelay: 200, //milliseconds
  };
  private retryOptionConfigured = false;

  constructor(private authenticationService: AuthenticationService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.authenticationService.obterTokenUsuario;
    const isLoggedIn = !!token && token !== 'null';
    const isApiUrl = request.url.startsWith(environment.api_url);
    if (isLoggedIn && isApiUrl) {
      request = request.clone({
        setHeaders: { Authorization: `Bearer ${token}` }
      });
    }

    request = request.clone({
      setHeaders: {
        'custom-header-chave': environment.chave_weblab,
      }
    });

    // first time it run: need to replace default retry config options
    // if (!this.retryOptionConfigured) {
    //   let appConfig = this.appConfigService.getConfig();
    //   if (appConfig) {
    //     this.retryRequestOptions = {
    //       maximumRetries: appConfig.maximumRetries,
    //       retryDelay: appConfig.retryDelay,
    //     };
    //     this.retryOptionConfigured = true;
    //   }
    // }

    return next.handle(request).pipe(this.retryPipe());

    // return next.handle(request).pipe(
    //   catchError((err: HttpErrorResponse) => {
    //     if (err) {
    //       switch (err.status) {
    //         case 401:
    //           this.authenticationService.tokenExpiradoEmit(true);
    //           break;
    //         default:
    //           break;
    //       }
    //     }
    //     throw err;
    //   })
    // );
  }

  retryPipe<T>() {
    return retryWhen<T>((errors: Observable<HttpErrorResponse>) =>
      errors.pipe(
        // Use concat map to keep the errors in order and make sure they
        // aren't executed in parallel
        concatMap((error: HttpErrorResponse, retryId: number) =>
          // Executes a conditional Observable depending on the result
          // of the first argument
          iif(
            () => retryId >= this.retryRequestOptions.maximumRetries ||
              (error.status <= 500 && !(error.url ?? '').includes('/v1/clientes') && !(error.url ?? '').includes('/v1/lojas')),
            // If the condition is true we throw the error (the last error)
            this.returnError(error),
            // Otherwise we pipe this back into our stream and delay the retry
            this.retryError(error, retryId, this.retryRequestOptions.retryDelay),
          ),
        ),
      ),
    );
  }
  returnError(err: HttpErrorResponse) {
    if (err) {
      switch (err.status) {
        case 401:
          this.authenticationService.tokenExpiradoEmit(true);
          break;
        default:
          break;
      }
    }
    // throw err;
    return throwError(err);
  }

  retryError(error: HttpErrorResponse, retryId: number, retryDelay: number) {
    console.log('retry', error.url, retryDelay, retryId)
    // retry request with increasing delay between each attemp
    return of(error).pipe(delay(retryDelay * retryId));
  }
}
